import {
  ELEMENT_ATTRIBUTE_GROUP,
  ELEMENT_GROUPS
} from '../../../../AppDesigner/Elements';

const fields = {
  group: ELEMENT_GROUPS.TEXT,
  name: 'OAuthLoginResponseHandler',
  label: 'OAuth Login Response Handler',
  icon: 'DocumentTextIcon',
  description: 'Handles OAuth Login responses from an OAuth login provider',
  properties: [
    {
      label: 'On Success Action Sequence Id',
      name: 'onSuccessActionSequenceId',
      editor: 'textbox',
      readonly: false,
      description:
        'The ID of an action sequence to run when the OAuth login succeeds',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'On Failure Action Sequence Id',
      name: 'onFailureActionSequenceId',
      editor: 'textbox',
      readonly: false,
      description:
        'The ID of an action sequence to run when the OAuth login fails',
      options: [],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    }
  ]
};

export default fields;
